import { useParams } from "react-router-dom";
import { ServicesData, defaultData } from "./StaticData/HomeServiceData";

import { useState, useEffect } from "react";
import HomeHeader from "../Component/HomeComponent/HomeHeader";
import ServiceCardRow from "../Component/HomeComponent/ServiceCardRow";
import { useLocation } from "react-router-dom";
import ArrowCarousel from "../Component/HomeComponent/ArrowCarousel";
import HomeFooter from "../Component/HomeComponent/HomeFooter";
import {
  PageContainer,
  FirstSectionContainer,
  TitleContainer,
  DetailsContainer,
  SectionContainer,
  SubPageTitle,
} from "../Component/HomeComponent/GeneralComponents";
import TransparentCard from "../Component/HomeComponent/TransparentCard";

export default function HomeService() {
  let { page } = useParams();
  const [ismobile, setIsMobile] = useState(0);
  const location = useLocation();
  const [key, setKey] = useState(0);
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
    setKey((prevKey) => prevKey + 1);
  }, [location]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const serviceData = ServicesData.find(
      (service) => service.link.split("/").pop() === page
    );
    if (serviceData) {
      setData(serviceData);
    } else {
      setData(defaultData);
    }
  }, [page]);

  return (
    <PageContainer key={key}>
      <HomeHeader />
      <FirstSectionContainer ismobile={ismobile} bg={data.image}>
        <TitleContainer
          ismobile={ismobile}
          style={{ paddingTop: "15vh", width: "40vw" }}
        >
          {data.title}
        </TitleContainer>
        <DetailsContainer
          ismobile={ismobile}
          style={{
            paddingTop: ismobile ? "5vh" : "10vh",
            width: ismobile ? "80vw" : "40vw",
            lineHeight: 1.2,
            fontWeight: 400,
          }}
        >
          {data.description}
        </DetailsContainer>
      </FirstSectionContainer>
      <SectionContainer>
        <SubPageTitle ismobile={ismobile}>Why is it valuable?</SubPageTitle>
        <ServiceCardRow hovermode={false}>
          {data.content.slice(0, 3)}
        </ServiceCardRow>
      </SectionContainer>
      <SectionContainer>
        <SubPageTitle ismobile={ismobile}>How do we do it?</SubPageTitle>
        <ServiceCardRow hovermode={false}>
          {data.content.slice(3, 6)}
        </ServiceCardRow>
      </SectionContainer>
      <SectionContainer>
        <SubPageTitle ismobile={ismobile}>More of Our Services</SubPageTitle>
        <ArrowCarousel
          more={true}
          style={{
            width: ismobile ? "80vw" : "50vw",
            height: ismobile ? "50vh" : "80vh",
            margin: "auto",
            display: "flex",

            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {ServicesData.map((service, index) => {
            if (service.link.split("/").pop() !== page) {
              return (
                <TransparentCard
                  option={service}
                  key={index + service.title}
                  zoom={0}
                />
              );
            } else {
              return null;
            }
          })}
        </ArrowCarousel>
      </SectionContainer>
      <HomeFooter />
    </PageContainer>
  );
}
